export default { sha: '03326aba732be1600b28e89bbe88d4fcaaba66d3', buildNumber: 'undefined' }
